// Function to handle dropdown functionality
function setupDropdown(
  columnId,
  dropdownBtnId,
  dropdownMenuId,
  dropdownIconId,
  productBoxesClass,
  dropdownBtnTextId,
  menuBtnClass
) {
  const dropdownButton = document.getElementById(dropdownBtnId);
  const dropdownMenu = document.getElementById(dropdownMenuId);
  const dropdownIcon = document.getElementById(dropdownIconId);
  const productBoxes = document.querySelectorAll(productBoxesClass);
  const dropdownButtonText = document.getElementById(dropdownBtnTextId);

  // Function to open the dropdown menu
  const openDropdown = () => {
    dropdownMenu.classList.remove("d-none");
    dropdownMenu.classList.add("d-block");
    dropdownIcon.style.transform = "rotate(180deg)";
  };

  // Function to close the dropdown menu
  const closeDropdown = () => {
    dropdownMenu.classList.remove("d-block");
    dropdownMenu.classList.add("d-none");
    dropdownIcon.style.transform = "rotate(0deg)";
  };

  // Toggle the dropdown menu on button click
  const toggleDropdown = () => {
    if (dropdownMenu.classList.contains("d-none")) {
      openDropdown();
    } else {
      closeDropdown();
    }
  };

  // Toggle the dropdown menu on button click
  dropdownButton.addEventListener("click", toggleDropdown);

  // Close dropdown when clicking outside of the menu
  document.addEventListener("click", (event) => {
    if (
      !dropdownMenu.contains(event.target) &&
      event.target !== dropdownButton &&
      event.target !== dropdownIcon
    ) {
      closeDropdown();
    }
  });

  // Show respective product box when an option is selected and update dropdown button text
  const dropdownMenuItems = dropdownMenu.querySelectorAll(menuBtnClass);
  dropdownMenuItems.forEach((item) => {
    item.addEventListener("click", () => {
      const selectedProductId = item.id.replace("-menu-", "-product-");
      productBoxes.forEach((box) => {
        if (box.id === selectedProductId) {
          box.classList.remove("d-none");
          dropdownButtonText.innerText = item.innerText; // Update dropdown button text
        } else {
          box.classList.add("d-none");
        }
      });
      closeDropdown();
    });
  });
}

// Set up dropdown functionality for each column
document.addEventListener("DOMContentLoaded", () => {
  setupDropdown(
    "dell-cm__column-a",
    "dell-cm__column-a-dropbtn",
    "dell-cm__column-a-dropmenu",
    "dell-cm__column-a-dropbtn-icon",
    ".dell-comparison-module__product-box-a",
    "dell-cm__column-a-dropbtn-text",
    ".dell-comparison-module__dropdown-a-menu-btn"
  );

  setupDropdown(
    "dell-cm__column-b",
    "dell-cm__column-b-dropbtn",
    "dell-cm__column-b-dropmenu",
    "dell-cm__column-b-dropbtn-icon",
    ".dell-comparison-module__product-box-b",
    "dell-cm__column-b-dropbtn-text",
    ".dell-comparison-module__dropdown-b-menu-btn"
  );

  setupDropdown(
    "dell-cm__column-c",
    "dell-cm__column-c-dropbtn",
    "dell-cm__column-c-dropmenu",
    "dell-cm__column-c-dropbtn-icon",
    ".dell-comparison-module__product-box-c",
    "dell-cm__column-c-dropbtn-text",
    ".dell-comparison-module__dropdown-c-menu-btn"
  );
});
